// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for the navigation bar */
.nav-bar {
  display: flex;
  justify-content: space-between;
  /* Distribute items */
  background-color: #b9becf;
  /* Dark background for the navbar */
  padding: 8px 16px;
  /* Adds padding to the navbar */
  min-height: 60px;
  /* Set minimum height */
  align-items: center;
  font-size: 30px;
  font-weight: 600;
  color: rgb(50, 43, 77);
  position: relative;
  flex-wrap: wrap;
  /* allow wrapping on small screens */

}

/* Styling for each link */
.nav-bar a {
  text-decoration: none;
  color: rgb(52, 15, 52);
  /* White text color */
  padding: 10px 20px;
  /* Adds padding around each link */
  margin: 0 15px;
  /* Adds space between the links */
  font-size: 1.1rem;

}

.nav-bar a:hover {
  background-color: #575757;
  /* Light grey background on hover */
  border-radius: 5px;
  /* Round corners on hover */
}

.nav-bar .brand-link {
  text-decoration: none;
  color: rgba(12, 4, 73, 0.921);
  font-size: 22px;
  font-weight: 700;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Container for nav content with margins */
.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  /* Adjust based on your needs */
  margin: 0 40px;
  /* Add margin on both sides */
  padding: 0 20px;
}

/* Responsive behaviour */
@media (max-width: 768px) {
  .nav-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin: 0 12px;
    padding: 0;
  }

  .nav-links {
    width: 100%;
    flex-wrap: wrap;
    gap: 6px;
  }

  .nav-links .nav-link {
    padding: 8px 12px;
  }

  .nav-bar .brand-link {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/NavBar.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;;AAEtC;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,iCAAiC;EACjC,iBAAiB;;AAEnB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Basic styling for the navigation bar */\n.nav-bar {\n  display: flex;\n  justify-content: space-between;\n  /* Distribute items */\n  background-color: #b9becf;\n  /* Dark background for the navbar */\n  padding: 8px 16px;\n  /* Adds padding to the navbar */\n  min-height: 60px;\n  /* Set minimum height */\n  align-items: center;\n  font-size: 30px;\n  font-weight: 600;\n  color: rgb(50, 43, 77);\n  position: relative;\n  flex-wrap: wrap;\n  /* allow wrapping on small screens */\n\n}\n\n/* Styling for each link */\n.nav-bar a {\n  text-decoration: none;\n  color: rgb(52, 15, 52);\n  /* White text color */\n  padding: 10px 20px;\n  /* Adds padding around each link */\n  margin: 0 15px;\n  /* Adds space between the links */\n  font-size: 1.1rem;\n\n}\n\n.nav-bar a:hover {\n  background-color: #575757;\n  /* Light grey background on hover */\n  border-radius: 5px;\n  /* Round corners on hover */\n}\n\n.nav-bar .brand-link {\n  text-decoration: none;\n  color: rgba(12, 4, 73, 0.921);\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Container for nav content with margins */\n.nav-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1200px;\n  /* Adjust based on your needs */\n  margin: 0 40px;\n  /* Add margin on both sides */\n  padding: 0 20px;\n}\n\n/* Responsive behaviour */\n@media (max-width: 768px) {\n  .nav-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    margin: 0 12px;\n    padding: 0;\n  }\n\n  .nav-links {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .nav-links .nav-link {\n    padding: 8px 12px;\n  }\n\n  .nav-bar .brand-link {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
